package games.mythical.saga.watcher.sagawatcher.model

import kotlinx.serialization.Serializable

@Serializable
data class Environment(
    val name: String,
    val version: String,
)